import React from "react";
import Button from "../../atoms/button/button";
import "./modal.scss";

interface IModal {
    image: string;
    title: string;
    textButton: string;
    url: string;
    textButtonOpcional?: string;
    urlOpcional?: string;
    onClosedModal?: () => void;
    openSelf? : boolean;
    children?: any;
    classNames?: {
      modal?: string;
      title?: string;
      ctaBtn?: string;
      ctaBtnVariant?: string;
    };
}
const Modal: React.FC<IModal> = ({
    image,
    title,
    textButton,
    url,
    textButtonOpcional,
    urlOpcional,
    onClosedModal,
    openSelf,
    children,
    classNames,
}) => {
      const ctaBtnVariant = classNames?.ctaBtnVariant || "a-button__magenta";
    return (
        <div className={`m-modal ${classNames?.modal}`} >
           {onClosedModal ? <div class="m-modal__closemodal" onClick={onClosedModal}>&times;</div> : null}
            <img className="m-modal__image" src={image} alt={title} />
            <h2 className={`m-modal__title ${classNames?.title}`}>{title}</h2>
            {children}
            <Button
                type="link"
                text={textButton}
                classname={` ${ctaBtnVariant} m-modal__button a_button__big gtmFormModalButton-${textButton.replace(
                    / /g,
                    ""
                )} ${classNames?.ctaBtn}`}
                href={url}
                self={openSelf}
                isDisabled={false}
            />
            {textButtonOpcional && (
            <Button
                type={urlOpcional === "" ? "button"  : "link"}
                text={textButtonOpcional}
                classname={`a-button__magenta m-modal__button-opt gtmFormModalButton-${textButton.replace(
                    / /g,
                    ""
                )}`}
                href={urlOpcional === "" ? urlOpcional : ""} 
                onClickAction={onClosedModal}
                isDisabled={false}
            />)}
        </div>
    );
};

export default Modal;
